import * as Sentry from '@sentry/react';
import { backendApi } from '_config';
import { handleError } from '_services/Api/Api';
import Csrf from '_services/Api/Csrf';
import axios from 'axios';
import { xsrfTokenRequestInterceptor } from '../../../_utils/xsrfInterceptor';

const ApiWithFileUpload = axios.create({
    baseURL: backendApi,
    withCredentials: true,
});

ApiWithFileUpload.interceptors.response.use(
    (response) => Promise.resolve(response),
    async (error) => {
        const responseStatus = error.response?.status;
        const originalConfig = error.config ?? {};

        // Special handling for CSRF 419: refresh cookie and retry once
        if (
            (responseStatus === 419 || responseStatus === '419') &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !(originalConfig as any)._csrfRetried
        ) {
            try {
                Sentry.addBreadcrumb({
                    category: 'csrf',
                    level: 'info',
                    message:
                        'CSRF 419 received (upload): refreshing cookie and retrying',
                    data: {
                        url: originalConfig.url,
                        method: originalConfig.method,
                        baseURL: originalConfig.baseURL,
                    },
                });
                await Csrf.createCsrfCookie();
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (originalConfig as any)._csrfRetried = true;
                return ApiWithFileUpload(originalConfig);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                Sentry.addBreadcrumb({
                    category: 'csrf',
                    level: 'error',
                    message: 'CSRF retry failed (upload) after refresh',
                    data: {
                        url: originalConfig.url,
                        method: originalConfig.method,
                    },
                });
                // fall through to standard handling
            }
        }

        // handling error here
        return Promise.reject(handleError(responseStatus, error));
    },
);
ApiWithFileUpload.interceptors.request.use(xsrfTokenRequestInterceptor);

export default ApiWithFileUpload;
